import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { gaTagsConfig } from './ga-tags-config/ga-tags-config';
import { ClaimsFeatureShellModule } from '@domgen/feature-shell';

@NgModule({
  declarations: [AppComponent],
  imports: [
    ClaimsFeatureShellModule.forRoot({
      gaTagsConfig
    })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
